import Description from './Description'
import Review from './Review'
import Details from './Details'
import Cite from './Cite'

export default Object.assign(Review, {
  Description,
  Details,
  Cite,
})
